module.exports = __webpack_public_path__ + "img/xwdt_bg.434e0177.png";